// removed by extract-text-webpack-plugin
module.exports = {"container":"_2-nDzHkhiZ6EIjrblq6i7O","header":"_2P2jUDYori3jPUvS57xRiM","favorite":"_3-btRXnGiPg5s5KqPeTgfZ","active":"Aw43JJ73A4a2BcEb00QCD","wrapper":"_3LkoTVPecBnEp2S62718dj"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/VideoStep.mod.css
// module id = 1692
// module chunks = 0